import "./App.css";
import Chat from "./pages/Chat";

function App() {
  return (
    <div className="App">
      <Chat />
    </div>
  );
}

export default App;
